module.exports = __webpack_public_path__ + "static/media/pict.acbc097c.png";